@if (form) {
  <form [formGroup]="form" class="pb-6">
    @if (attributes$ | async; as attributes) {
      @if (attributes.projectScopeFromMDM) {
        <app-attribute-readonly [label]="'totalBuildingObjects' | attributeKeyTranslate"
        [value]="attributes.totalBuildingObjects ?? '-'"></app-attribute-readonly>
        <app-attribute-readonly [label]="'surfaceBVO' | attributeKeyTranslate"
        [value]="attributes.surfaceBVO ? attributes.surfaceBVO + ' m²' : '-'"></app-attribute-readonly>
        <app-attribute-readonly [label]="'surfaceLot' | attributeKeyTranslate"
        [value]="attributes.surfaceLot ? attributes.surfaceLot + ' m²' : '-'"></app-attribute-readonly>
        <app-attribute-readonly [label]="'grossVolume' | attributeKeyTranslate"
        [value]="attributes.grossVolume ? attributes.grossVolume + ' m³' : '-'"></app-attribute-readonly>
        <app-attribute-readonly [label]="'unitsForSale' | attributeKeyTranslate"
        [value]="attributes.unitsForSale ?? '-'"></app-attribute-readonly>
        <app-attribute-readonly [label]="'unitsForRent' | attributeKeyTranslate"
        [value]="attributes.unitsForRent ?? '-'"></app-attribute-readonly>
      }
      @if (!attributes.projectScopeFromMDM) {
        <app-attribute-editable [label]="'totalBuildingObjects' | attributeKeyTranslate" class="block flex-1"
        formControlName="totalBuildingObjects" inputType="text"></app-attribute-editable>
        <app-attribute-editable [label]="'surfaceBVO' | attributeKeyTranslate" class="block flex-1"
        formControlName="surfaceBVO" inputType="number" valueSuffix="m²"></app-attribute-editable>
        <app-attribute-editable [label]="'surfaceLot' | attributeKeyTranslate" class="block flex-1"
        formControlName="surfaceLot" inputType="number"></app-attribute-editable>
        <app-attribute-editable [label]="'grossVolume' | attributeKeyTranslate" class="block flex-1"
        formControlName="grossVolume" inputType="number" valueSuffix="m³"></app-attribute-editable>
        <app-attribute-editable [label]="'unitsForSale' | attributeKeyTranslate" class="block flex-1"
        formControlName="unitsForSale" inputType="number"></app-attribute-editable>
        <app-attribute-editable [label]="'unitsForRent' | attributeKeyTranslate" class="block flex-1"
        formControlName="unitsForRent" inputType="number"></app-attribute-editable>
      }
      <app-attribute-readonly
        [label]="'type' | attributeKeyTranslate"
        value="{{attributes.readonlyAttributes.type | formatAttributeValue}}"
      ></app-attribute-readonly>
      <app-attribute-editable
        [label]="'coreDataProject' | attributeKeyTranslate"
        class="block flex-1"
        formControlName="coreDataProject"
        inputType="text"
      ></app-attribute-editable>
      <app-attribute-readonly
        [label]="'buildingClassification' | attributeKeyTranslate"
        value="{{attributes.readonlyAttributes.buildingClassification | formatAttributeValue}}"
      ></app-attribute-readonly>
      <app-attribute-readonly
        [label]="'buildingSubClassification' | attributeKeyTranslate"
        value="{{attributes.readonlyAttributes.buildingSubClassification | formatAttributeValue}}"
      ></app-attribute-readonly>
      <app-attribute-readonly
        [label]="'vwConcept' | attributeKeyTranslate"
        value="{{attributes.readonlyAttributes.vwConcept | formatAttributeValue}}"
      ></app-attribute-readonly>
      <app-attribute-readonly
        [label]="'sustainabilityClass' | attributeKeyTranslate"
        value="{{attributes.readonlyAttributes.sustainabilityClass | formatAttributeValue}}"
      ></app-attribute-readonly>
      <app-attribute-project-editable [label]="attributes.urbanDensity?.title" [attribute]="attributes.urbanDensity"
      formControlName="urbanDensity"></app-attribute-project-editable>
      <app-attribute-editable [label]="'surfaceVVO' | attributeKeyTranslate" class="block flex-1" formControlName="surfaceVVO"
      inputType="number" valueSuffix="m²"></app-attribute-editable>
      <app-attribute-editable [label]="'surfaceFacade' | attributeKeyTranslate" class="block flex-1" formControlName="surfaceFacade"
      inputType="number" valueSuffix="m²"></app-attribute-editable>
      <app-attribute-editable [label]="'locationSize' | attributeKeyTranslate" class="block flex-1" formControlName="locationSize"
      inputType="number" valueSuffix="m²"></app-attribute-editable>
      <app-attribute-editable [label]="'buildingLayersAboveGround' | attributeKeyTranslate" class="block flex-1"
      formControlName="buildingLayersAboveGround" inputType="number"></app-attribute-editable>
      <app-attribute-editable [label]="'buildingLayersUnderGround' | attributeKeyTranslate" class="block flex-1"
      formControlName="buildingLayersUnderGround" inputType="number"></app-attribute-editable>
      <app-attribute-editable [label]="'demolitionSize' | attributeKeyTranslate" class="block flex-1" formControlName="demolitionSize"
      inputType="number" valueSuffix="m²"></app-attribute-editable>
      <app-attribute-editable [label]="'remediateSize' | attributeKeyTranslate" class="block flex-1" formControlName="remediateSize"
      inputType="number" valueSuffix="m²"></app-attribute-editable>
      <app-attribute-editable [label]="'readyForConstructionSize' | attributeKeyTranslate" class="block flex-1"
      formControlName="readyForConstructionSize" inputType="number" valueSuffix="m²"></app-attribute-editable>
      <app-attribute-editable [label]="'readyToLiveSize' | attributeKeyTranslate" class="block flex-1" formControlName="readyToLiveSize"
      inputType="number" valueSuffix="m²"></app-attribute-editable>
      <app-attribute-project-editable [label]="attributes.energyLabel?.title" [attribute]="attributes.energyLabel"
        formControlName="energyLabel">
      </app-attribute-project-editable>
      <app-attribute-project-editable [label]="attributes.riskManagement?.title" [attribute]="attributes.riskManagement"
        formControlName="riskManagement">
      </app-attribute-project-editable>
      <app-attribute-editable [label]="'keyFeatures' | attributeKeyTranslate" class="block flex-1" formControlName="keyFeatures"
      inputType="text"></app-attribute-editable>
      <app-attribute-editable [label]="'maintanceContractYears' | attributeKeyTranslate" class="block flex-1"
      formControlName="maintanceContractYears" inputType="number"></app-attribute-editable>
    }
  </form>
}
